module.exports = __webpack_public_path__ + "static/media/11.3caf6199.png";